import type { ColumnDef } from '@tanstack/react-table';

import { type GetPaginatedFilteredSuppliersQuery } from 'data/__generated__';
import { textColumn } from 'components/DataTable';

export type SupplierRow = GetPaginatedFilteredSuppliersQuery['paginatedFilteredSuppliers']['suppliers'][number];

export type SuppliersFilterInput = {
    filterString?: string;
    shouldHideArchived?: boolean;
};

export const suppliersColumns: ColumnDef<SupplierRow, unknown>[] = [
    textColumn<SupplierRow, SuppliersFilterInput>({
        accessorKey: 'name',
        header: 'Nom',
        defaultVisible: true,
    }),
    textColumn<SupplierRow, SuppliersFilterInput>({
        accessorKey: '_id',
        header: 'ID',
        defaultVisible: true,
    }),
];
